import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { PagamentoNewFactory } from '../../factories/PagamentoNew'
import { PagamentoFactory } from '../../factories'
import { IValidateUseNewHome } from '../../domain/usecases/ValidateUseNewHome'
import LoadingBackdrop from '../../../../shared/components/LoadingBackdrop'

interface HomePagamentoProp {
  validUseNewHome: IValidateUseNewHome
}
const HomePagamento: FunctionComponent<HomePagamentoProp> = ({
  validUseNewHome,
}) => {
  const [isNewHome, setIsNewHome] = useState(undefined)
  const [loading, setLoading] = useState(false)

  const HomeComponent = useMemo(() => {
    switch (isNewHome) {
      case undefined:
        return <></>
      case true:
        return <PagamentoNewFactory />
      default:
        return <PagamentoFactory />
    }
  }, [isNewHome])

  const handleShouldUseNewHome = useCallback(async () => {
    try {
      setLoading(true)
      const shouldUseNewHome = await validUseNewHome.execute()
      setIsNewHome(shouldUseNewHome.useNewHome)
    } catch (e) {
      setIsNewHome(false)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    handleShouldUseNewHome()
    return () => {
      return null
    }
  }, [])

  return (
    <>
      <LoadingBackdrop open={loading} />
      {HomeComponent}
    </>
  )
}

export default HomePagamento
